import { isDefined } from "@clipboard-health/util-ts";
import { isEqual } from "lodash";

import { type ComputedArrival } from "../types";

interface ShiftWithComputedArrivals {
  computedArrivals?: ComputedArrival[];
  agentId?: string;
  bookedAt?: string;
  start: string;
}

/**
 * Gets the most recent computed arrival for a worker based on their agentId, bookedAt time, and shift start time.
 * Uses findLast to get the latest matching arrival if multiple exist.
 */
export function getComputedArrivalForWorker(
  shift: ShiftWithComputedArrivals
): ComputedArrival | undefined {
  const { computedArrivals, agentId, bookedAt, start } = shift;

  if (!computedArrivals || !agentId || !bookedAt) {
    return undefined;
  }

  return computedArrivals.findLast(
    (arrival) =>
      isDefined(arrival.workerId) &&
      arrival.workerId.toString() === agentId.toString() &&
      isEqual(arrival.bookedAt, bookedAt) &&
      isEqual(arrival.shiftStartAt, start)
  );
}
